import React from 'react';
const TranslationsContext = React.createContext({});
export default TranslationsContext;


// WEBPACK FOOTER //
// ./src/universal/components/translations/translations-context.js